import React, { useEffect, useState } from "react";
import axios from "axios";

const UserGrowth = () => {
 const [data, setData] = useState([]);

 useEffect(() => {
 const fetchUserGrowth = async () => {
 try {
 const res = await axios.get(
 `${process.env.REACT_APP_BASE_URL}/admin/analytics/users-growth`
 );
 setData(res.data);
 } catch (error) {
 }
 };
 fetchUserGrowth();
 }, []);

 return (
 <div className="widget">
 <h3>User Growth</h3>
 <ul>
 {data.length === 0 && <li>No data</li>}
 {data.map((item) => (
 <li key={item.date}>
 {item.date}: {item.newUsers} new users
 </li>
 ))}
 </ul>
 </div>
 );
};

export default UserGrowth;
